/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExpectedSourcingProcess = {
    Delegated: 'DELEGATED',
    ProvidedOnlySelection: 'PROVIDED_ONLY_SELECTION',
    WithAssistance: 'WITH_ASSISTANCE'
} as const;
export type ExpectedSourcingProcess = typeof ExpectedSourcingProcess[keyof typeof ExpectedSourcingProcess];


export function instanceOfExpectedSourcingProcess(value: any): boolean {
    for (const key in ExpectedSourcingProcess) {
        if (Object.prototype.hasOwnProperty.call(ExpectedSourcingProcess, key)) {
            // @ts-ignore
            if (ExpectedSourcingProcess[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExpectedSourcingProcessFromJSON(json: any): ExpectedSourcingProcess {
    return ExpectedSourcingProcessFromJSONTyped(json, false);
}

export function ExpectedSourcingProcessFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpectedSourcingProcess {
    return json as ExpectedSourcingProcess;
}

export function ExpectedSourcingProcessToJSON(value?: ExpectedSourcingProcess | null): any {
    return value as any;
}

